import { resolveSpaceLabelFit } from 'utils/space-label-fit';
import type {
  SpaceLabelLayoutInput,
  SpaceLabelLayoutResult
} from 'utils/space-label-layout-types';
import {
  findInsideSpaceLabelAnchor,
  getSpaceLabelAnchor
} from 'utils/space-label-position';
import { abbreviateSpaceName } from 'utils/space-name-abbreviation';

export type {
  SpaceLabelLayoutInput,
  SpaceLabelLayoutResult
} from 'utils/space-label-layout-types';

export function resolveSpaceLabelLayout(
  input: SpaceLabelLayoutInput
): SpaceLabelLayoutResult {
  const obstacles = input.obstacles ?? [];
  const fit = resolveSpaceLabelFit(input);
  const insideAnchor = findInsideSpaceLabelAnchor(
    input.vertices,
    fit.worldSize,
    obstacles
  );
  if (insideAnchor) {
    return { ...fit, anchor: insideAnchor };
  }

  if (obstacles.length === 0) {
    return {
      ...fit,
      anchor: getSpaceLabelAnchor(input.vertices, fit.worldSize, obstacles)
    };
  }

  if (fit.isAbbreviated) {
    const zeroClearanceAnchor = findInsideSpaceLabelAnchor(
      input.vertices,
      fit.worldSize,
      obstacles,
      0
    );
    return {
      ...fit,
      anchor:
        zeroClearanceAnchor ??
        getSpaceLabelAnchor(input.vertices, fit.worldSize, obstacles)
    };
  }

  const abbreviatedFit = resolveSpaceLabelFit({
    ...input,
    label: abbreviateSpaceName(input.label)
  });
  const abbreviatedAnchor =
    findInsideSpaceLabelAnchor(
      input.vertices,
      abbreviatedFit.worldSize,
      obstacles
    ) ??
    findInsideSpaceLabelAnchor(
      input.vertices,
      abbreviatedFit.worldSize,
      obstacles,
      0
    ) ??
    getSpaceLabelAnchor(input.vertices, abbreviatedFit.worldSize, obstacles);
  return {
    ...abbreviatedFit,
    isAbbreviated: abbreviatedFit.displayLabel !== input.label,
    anchor: abbreviatedAnchor
  };
}
